export { T as TRPCContext, h as contextProps, c as createHooksInternal, b as createReactProxyDecoration, a as createReactQueryUtilsProxy, f as createRootHooks, e as createUseQueriesProxy, d as getClientArgs } from '../createHooksInternal-063195fc.mjs';
export { g as getQueryClient } from '../queryClient-4d766c0c.mjs';
import '@trpc/server/shared';
import '../getArrayQueryKey-86134f8b.mjs';
import '@trpc/client';
import '@tanstack/react-query';
import 'react';
